export const escapeHtml = (value) => {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

export const findAllMatches = (messages, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return [];

  const list = [];
  messages.forEach((msg, messageIndex) => {
    const content = msg.content || "";
    const lower = content.toLowerCase();
    let pos = 0;
    let idx;
    while ((idx = lower.indexOf(term, pos)) !== -1) {
      list.push({
        messageIndex,
        start: idx,
        end: idx + term.length,
        globalIndex: list.length,
      });
      pos = idx + 1;
    }
  });
  return list;
};

export const buildHighlightedHtml = (content, matchesInMessage, currentMatchIndex) => {
  if (matchesInMessage.length === 0) return escapeHtml(content);

  let html = "";
  let lastEnd = 0;
  matchesInMessage.forEach(({ start, end, globalIndex }) => {
    if (start > lastEnd) {
      html += escapeHtml(content.slice(lastEnd, start));
    }
    const slice = escapeHtml(content.slice(start, end));
    const className = globalIndex === currentMatchIndex ? "highlight-current" : "highlight-other";
    html += `<span class="${className}">${slice}</span>`;
    lastEnd = end;
  });
  if (lastEnd < content.length) {
    html += escapeHtml(content.slice(lastEnd));
  }
  return html;
};

/**
 * Inserts highlight <mark> tags into markdown content without escaping the rest.
 * Use for agent messages so search highlights keep markdown rendering.
 */
export const buildMarkdownWithHighlights = (content, matchesInMessage, currentMatchIndex) => {
  if (!content || matchesInMessage.length === 0) return content;

  const parts = [];
  let lastEnd = 0;
  matchesInMessage.forEach(({ start, end, globalIndex }) => {
    if (start > lastEnd) {
      parts.push(content.slice(lastEnd, start));
    }
    const slice = content.slice(start, end);
    const className = globalIndex === currentMatchIndex ? "highlight-current" : "highlight-other";
    parts.push(`<mark class="${className}">${escapeHtml(slice)}</mark>`);
    lastEnd = end;
  });
  if (lastEnd < content.length) {
    parts.push(content.slice(lastEnd));
  }
  return parts.join("");
};
